module.exports = __webpack_public_path__ + "static/img/news_16.a245275.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news/news_16.jpg
// module id = xlUw
// module chunks = 2